import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { getContentKeyAccToLang, showToast } from "../../utils/utils";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { getClientData } from "../../store/actions/investmentsAction";

export default () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const { isArabic, TextWeight, direction } = dynamicfunction();

  const { clientDetails, clientLoading } = useSelector((state) => state.investments);
  const { investmentContent } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.common);

  const [isSecure, setIsSecure] = useState(true);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      investmentContent?.web_investment_overview?.data?.attributes,
      key,
      isArabic
    );
  };

  useEffect(() => {
    const search = location.search;
    const queryIndex = search.indexOf("?");
    if (queryIndex !== -1) {
      const queryString = search.substring(queryIndex + 1);
      const searchParams = new URLSearchParams(queryString);

      const status = searchParams.get("status");
      const isPaid = status === "paid";

      if (status) {
        showToast({
          icon: isPaid ? "success" : "error",
          title: `Payment Successful`,
        });
      }
    }

    window.history.replaceState(null, "", "#" + location.pathname);
  }, []);

  useEffect(() => {
    dispatch(getClientData())
  }, [])

  return {
    clientDetails,
    getContentKey,
    clientLoading,
    TextWeight,
    direction,
    navigate,
    user,
    isSecure,
    setIsSecure,
    isArabic,
  };
};
